export default function Settings(){
  return (
    <div className="pt-24 px-10 uppercase text-lg font-semibold">
    Settings
  </div>
  )
}
